import React, { ReactNode } from 'react';
import {
  components,
  GroupBase,
  MenuListProps,
} from 'react-select';

import { Scrollbar } from 'app/design-system/components/Scrollbar';

import styles from './MultiSelectComponents.module.scss';

type Props<T, IsMulti extends boolean, Group extends GroupBase<T>> = {
  children: ReactNode;
  className?: string;
} & MenuListProps<T, IsMulti, Group>;

function MenuList<T, IsMulti extends boolean, Group extends GroupBase<T>>({
  children,
  className,
  ...props
}: Props<T, IsMulti, Group>): JSX.Element {
  return (
    <components.MenuList {...props}
                         className={className}>
      <Scrollbar className={styles.scrollContainer}
                 style={{ maxHeight: props.maxHeight }}>
        {children}
      </Scrollbar>
    </components.MenuList>
  );
}

export default MenuList;
